import { render, staticRenderFns } from "./staff-filter.vue?vue&type=template&id=5b50f9c6"
import script from "./staff-filter.vue?vue&type=script&lang=js"
export * from "./staff-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports